export default __webpack_public_path__ + "static/buildingConsensusBlogImage-ab20670459d35c2add75e00a90bbbf96.png";